import UrlParser from "@/module/Utils/UrlParser";

export default function (target: Element, trackingCode: string): void {
  if (UrlParser.getInstance().isWebFapiPreview()) {
    return;
  }

  const range = document.createRange();
  const documentFragment = range.createContextualFragment(trackingCode.trim());
  target.appendChild(documentFragment);
}
